<template>
    <div class="fake-browser-container" :style="{width: width ? width : '100%'}">
        <div class="nav">
            <div class="fake-buttons">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
            </div>
        </div>
        <div class="browser-content">
            <slot name="content" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "FakeBrowser",
        props: ['width']
    }
</script>

<style scoped lang="scss">
    .fake-browser-container {
        display: flex;
        flex-direction: column;
        box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.12), 0 16px 24px 0 rgba(0, 0, 0, 0.08);
        border: 1px solid var(--asphalt20);
        border-radius: 10px;
        width: 100%;
        height: 100%;
        overflow: hidden;

        transition-property: width, height;
        transition-duration: 100ms;
        transition-timing-function: cubic-bezier(0.22,0.61,0.36,1);

        max-width: 1600px;
        margin: auto;

        .browser-content {
            height: 100%;
        }

        .nav {
            display: flex;
            padding: 14px 14px;
            background-color: var(--asphalt10);

            .fake-buttons {
                display: flex;
                align-items: center;
                gap: 4px;

                .circle {
                    width: 8px;
                    height: 8px;
                    border-radius: 99px;
                    background-color: var(--asphalt30);
                }
            }
        }

        .content {
            width: 100%;
            height: 100%;
        }
    }
</style>